module.exports = __webpack_public_path__ + "static/media/shapes-paths.4.5a130083.svg";